/**
 * Dedicated membership checkout entry.
 * Enqueued by WordPress so Stripe confirm is not behind a webpack chunk.
 */

import {
    closeMembershipJoinModals,
    initMembershipJoinModal,
    openMembershipJoinModal,
    showMembershipOpenSuccess,
} from './membership-join-modal.js';
import { rememberMembershipCampaign } from './membership-stripe.js';

window.openMembershipJoinModal = openMembershipJoinModal;
window.closeMembershipJoinModals = closeMembershipJoinModals;
window.showMembershipOpenSuccess = showMembershipOpenSuccess;

function bootMembershipCheckout() {
    rememberMembershipCampaign();
    initMembershipJoinModal();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMembershipCheckout);
} else {
    bootMembershipCheckout();
}
